var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgZetaneLogo = function SvgZetaneLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.906 31.543h18.819c1.738 0 3.171.896 4.3 2.69l6.74 10.826H35.07c-1.713.06-3.089-.654-4.125-2.141l-7.038-11.375Z",
    fill: "url(#zetane-logo_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.124 33.641 7.172 11.167c.243.27.583.422.942.422h10.563a1.27 1.27 0 0 0 .943-2.121l-6.306-9.998c-.394-.625-.645-1.062-.757-1.44-.198-.668.035-1.157.677-2.175a513.967 513.967 0 0 1 2.764-4.323c.716-1.109 1.972-3.043 3.767-5.8.294-.495.42-.911.215-1.37a1.27 1.27 0 0 0-1.158-.755H15.238c-.36 0-.699.156-.942.42l-7.23 11.828c-.853 1.54-1.003 1.54-1.003 2.174 0 .634.15.634 1.061 1.971Z",
    fill: "url(#zetane-logo_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.122 33.612 7.172 11.167c.243.27.583.422.943.422H25.8a1.271 1.271 0 0 0 .943-2.121l-6.306-9.999c-.394-.624-.645-1.06-.758-1.44-.197-.668.035-1.156.678-2.175l6.386-10.123a1.274 1.274 0 0 0-.943-2.124H15.237c-.36 0-.7.155-.943.42l-7.23 11.827c-.852 1.541-1.003 1.541-1.003 2.175 0 .634.15.634 1.061 1.971Z",
    fill: "url(#zetane-logo_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.138 11.59 39.966.421A1.266 1.266 0 0 0 39.023 0H28.462a1.271 1.271 0 0 0-.943 2.122l6.306 9.998c.394.624.645 1.061.757 1.44.198.668-.035 1.157-.677 2.175l-6.386 10.123c-.271.444-.42.91-.215 1.369.205.46.659.755 1.158.755h10.563c.36 0 .699-.155.942-.42l7.23-11.827c.853-1.541 1.003-1.541 1.003-2.175 0-.633-.15-.633-1.061-1.97Z",
    fill: "url(#zetane-logo_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.14 11.62 39.966.454a1.266 1.266 0 0 0-.942-.423H28.462a1.27 1.27 0 0 0-.943 2.122l6.306 9.998c.394.624.645 1.061.757 1.44.198.668-.035 1.157-.677 2.175L27.52 25.89a1.273 1.273 0 0 0 .943 2.124h10.563c.36 0 .7-.155.942-.42l7.23-11.827c.853-1.54 1.003-1.541 1.003-2.175 0-.633-.15-.633-1.06-1.97Z",
    fill: "url(#zetane-logo_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.57.154h18.95c1.629 0 3.02.856 4.17 2.567l6.63 10.958H11.434c-1.714.06-3.086-.698-4.115-2.273L.57.154Z",
    fill: "url(#zetane-logo_svg__f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetane-logo_svg__a",
    x1: 38.836,
    y1: 45.062,
    x2: 38.836,
    y2: 31.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1280C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetane-logo_svg__b",
    x1: 16.634,
    y1: 31.239,
    x2: 16.634,
    y2: 13.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#800020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#540069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetane-logo_svg__c",
    x1: 16.565,
    y1: 45.201,
    x2: 16.565,
    y2: 31.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1280C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetane-logo_svg__d",
    x1: 37.696,
    y1: 31.517,
    x2: 37.696,
    y2: 13.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#800020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#540069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetane-logo_svg__e",
    x1: 37.697,
    y1: 14.022,
    x2: 37.697,
    y2: 0.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66027F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A2BE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetane-logo_svg__f",
    x1: 15.445,
    y1: 13.682,
    x2: 15.445,
    y2: 0.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66027F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A2BE1"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgZetaneLogo);
export default Memo;